import { CHECK_PENDING_CUSTOMERS } from './approvedCustomers';
import { SERVICE_CATEGORIES_GET_MANY } from './category';
import { resetClassState } from './class';
import { resetFileState } from './file';
import { resetGroupsState, resetGroupsState2, SERVICE_GROUPS_GET_MANY } from './group';
import { resetMembershipState } from './membership';
import { PLANS_GET_MANY } from './plan';
import { PROVIDER_COMPLETED_TASKS, PROVIDER_CREATE, PROVIDER_GET } from './provider';
import { resetResourceState } from './resource';
import { resetServiceState } from './service';
import { resetSessionState } from './session';
import { resetVideosState, USER_NOT_ACQUIRED_VIDEOS } from './video';
import { resetState } from '../actions';
import { CUSTOMERS_GET_MANY, PROVIDER_GET_SCHEDULE, PROVIDER_SUBSCRIPTION_GET } from '../types';
export * from './sqsMessage';
export * from './articles';
export * from './bodyMeasurements';
export * from './broadcast';
export * from './bundle';
export * from './calendar';
export * from './category';
export * from './class';
export * from './course';
export * from './customers';
export * from './event';
export * from './file';
export * from './group';
export * from './membership';
export * from './video';
export * from './section';
export * from './file';
export * from './payments';
export * from './plan';
export * from './provider';
export * from './providerAnalytics';
export * from './emailTemplate';
export * from './reservation';
export * from './resource';
export * from './section';
export * from './service';
export * from './session';
export * from './subscription';
export * from './subService';
export * from './video';
export * from './user';
export * from './userProviderFiles';
export * from './users';
export * from './userTrainingInfo';
export * from './translations';
export * from './workoutPlans';
export * from './workoutProgress';
export * from './workouts';
export * from './workoutsCustomer';
export * from './exercises';
export * from './equipments';
export * from './myVideos';
export * from './paymentOptions';
export * from './coursesAndEvents';
export * from './wallets';
export * from './zoom';
export * from './googleMeet';
export * from './orders';
export * from './approvedCustomers';
export * from './customersInvitationFlow';
export const resetProviderState = () => async dispatch => {
  dispatch(resetState(SERVICE_GROUPS_GET_MANY));
  dispatch(resetState(SERVICE_CATEGORIES_GET_MANY));
  dispatch(resetState(PROVIDER_SUBSCRIPTION_GET));
  dispatch(resetState(PROVIDER_GET));
  dispatch(resetState(PROVIDER_CREATE));
  dispatch(resetState(PLANS_GET_MANY));
  dispatch(resetState(CUSTOMERS_GET_MANY));
  dispatch(resetState(USER_NOT_ACQUIRED_VIDEOS));
  dispatch(resetState(PROVIDER_GET_SCHEDULE));
  dispatch(resetState(PROVIDER_COMPLETED_TASKS));
  dispatch(resetState(CHECK_PENDING_CUSTOMERS));
  dispatch(resetClassState());
  dispatch(resetServiceState());
  dispatch(resetSessionState());
  dispatch(resetMembershipState());
  dispatch(resetVideosState());
  dispatch(resetFileState());
  dispatch(resetResourceState());
  dispatch(resetGroupsState());
  dispatch(resetGroupsState2());
};